import {
  IonButton,
  IonHeader,
  IonModal,
} from "@ionic/react";
import React, { useContext, useState } from "react";
import "./AddPhoneNumberModal.scss";
import { utilService } from "../../../../services";
import { NurseManagementService } from "../../NurseManagementService";
import { AddPhoneNumberResponse } from "../../NurseMgmtDataModels";
import { NurseContext } from "../../NurseManagement";
import { useToast } from "@agney/ir-toast";
import { useTranslation } from "react-i18next";

interface modalProps {
  showModal: boolean;
  handleClose: Function;
  getPhoneList: Function;
}

const AddPhoneNumberModal = (props: modalProps) => {
  const Toast = useToast();
  const { t } = useTranslation("statusBoard");

  const nurseContextData = useContext(NurseContext);

  const [phone, setPhone] = useState("");

  const handleSave = async () => {
    if (phone.length !== 14) {
      Toast.error(
        t(
          "phoneValidation",
          "Phone number should have a minimum of 10 digits"
        )
      );
      return;
    }

    const addPhoneRes: AddPhoneNumberResponse =
      await NurseManagementService.addPhone({
        number: phone,
        reg_code: utilService.getNetwork(),
        unit_id: nurseContextData.selectedUnit,
      });

    if (addPhoneRes.isSuccess) {
      Toast.success(addPhoneRes.message); // backend message
      props.getPhoneList();
      props.handleClose(false);
    } else {
      Toast.error(addPhoneRes.message);
    }
  };

  const formatInput = (value: string, previousValue: string) => {
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    } else {
      if (cvLength === 0) return "";
      return value;
    }
  };

  const handleChange = (value: string) => {
    value && setPhone(formatInput(value, phone));
    !value && setPhone("");
  };

  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="add-phone-modal"
    >
      <IonHeader className="d-flex justify-content-between">
        <div>{t("addPhoneNumber")}</div>
        <span
          className="d-inline-block clickable"
          onClick={() => props.handleClose(false)}
        >
          {t("close")}
        </span>
      </IonHeader>

      <div className="modal-container">
        <div className="form-group">
          <input
            type="text"
            className="w-100 form-control"
            placeholder={t("phonePlaceholder")}
            maxLength={14}
            value={phone}
            onChange={(e) => handleChange(e.target.value)}
          />
        </div>

        <div>
          <IonButton
            className="button primary-btn btn-curved float-right"
            onClick={() => phone && handleSave()}
          >
            {t("save")}
          </IonButton>
        </div>
      </div>
    </IonModal>
  );
};

export default AddPhoneNumberModal;